import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=28cff522&scoped=true&"
import script from "./logo.vue?vue&type=script&lang=ts&"
export * from "./logo.vue?vue&type=script&lang=ts&"
import style0 from "./logo.vue?vue&type=style&index=0&id=28cff522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cff522",
  null
  
)

component.options.__file = "logo.vue"
export default component.exports